<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit && form.id != null ? `Edit Programme Scheme` : "Add Programme Scheme" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-autocomplete
              v-model.trim="form.program_id"
              label="Programme*"
              :items="programs"
              :item-text="
                (program) =>
                  `${program.degree?.short_name || ''}  ${
                    program.specialization ? ' - ' : ''
                  } ${program.specialization || ''}`
              "
              item-value="id"
              outlined
              dense
              bottom
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.name"
              label="Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="12"
            ><v-textarea
              v-model.trim="form.description"
              label="Description*"
              rows="2"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>

          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.required_credits"
              label="Credits*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.number]"
          /></v-col>
          <v-col cols="6"
            ><v-select
              v-model.trim="form.status"
              label="Status*"
              :items="['Draft', 'Published']"
              :disabled="!form.is_credits_matched"
              outlined
              dense
              bottom
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6">
            <v-radio-group
            v-model="form.handled_by"
            label="Handled by*"
            row
            dense
            :rules="[rules.required]"
            class="mt-0 pt-0"
            hide-details="auto"
          >
            <v-radio label="Institution" value="institution"></v-radio>
            <v-radio label="Partner" value="partner"></v-radio>
          </v-radio-group>
          </v-col>
          <v-col cols="6" v-if="form.handled_by === 'partner'"
            ><v-autocomplete
              v-model.trim="form.partner_id"
              label="Partner*"
              :items=filteredPartners
              item-text="name"
              item-value="id"
              outlined
              dense
              bottom
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit && form.id != null ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    program_scheme: {
      type: Object,
      default: () => {},
    },
    programs: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    partners: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {
        status: 'Draft'
      },
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      console.log(this.program_scheme);
      if (this.edit && this.program_scheme.is_copied) {
        this.form = { ...this.program_scheme };
        this.form.name = null;
      } else if (this.edit) {
        this.form = { ...this.program_scheme };
      }
      this.filteredPartners = this.partners.filter((p) => p.type !== "Institute");
    },

    save() {
      if(this.form.handled_by === 'institution') {
        const sasPartner = this.partners.find(p => p.type === 'Institute');
        if(sasPartner) this.form.partner_id = sasPartner.id;
      }
      if (this.$refs.form.validate()) {
        this.$emit(this.edit && this.form.id != null ? "update" : "create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
